<template>
  <div id="example">
    <!-- 头部结束 -->
    <div class="row">
      <div class="banner_schedule pc">
        <h1>精选案例</h1>
      </div>
      <div class="wap_banner_schedule mob">
        <h1>精选案例</h1>
      </div>
    </div>
    <div class="anli row" style="background:#ffffff;">
      <div class="all">
        <!-- <div class="kb1"></div> -->
        <ul class="row" style="padding-top: 25px;">
          <li class="col-lg-4 col-md-4 col-sm-4 anli_05" v-for="(item,index) in example" :key="'example'+index">
            <a @click.prevent="toNextPage(item.courseid)">
              <div class="wenzi">
                <h2>{{item.title}}</h2>
                <hr>
                <p>{{item.desc}}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import $ from 'jquery'

export default {
  name: 'Example',
  data () {
    return {
      example: []
    }
  },
  created () {
    // if(this.$router) console.log(this.$router);
    this.getExample()
  },
  methods: {
    toNextPage: function (e) {
      this.$router.push({path: '/course', name: 'Course', query: {sid: this.$route.query.sid, id: e}})
    },
    getExample: function () {
      // 所有课程
      var area_id = this.global.area_id
      if (this.$route.query.sid) {
        area_id = this.$route.query.sid
      }
      var url_course = this.global.url.course + area_id
      // console.log("url_course ", url_course, "  ", area_id);

      this.$http
        .jsonp(url_course)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          console.log('example ', data)
          this.example = []
          if (data.errno && data.errno.toString() === '0') {
            this.example = data.data
            // console.log(this.example);
          }
        })
      // var _this = this;
      // $.ajax({
      //   type: "get",
      //   url: url_course,
      //   dataType: "jsonp",
      //   success: function(obj) {
      //     // console.log(obj);
      //     if (obj.errno == 0) {
      //       $.each(obj.data, function(i, item) {
      //         if (i < obj.data.length) {
      //           var str =
      //             `<li class="col-lg-4 col-md-4 col-sm-4">
      //             <a>
      //             <div class="wenzi">
      //             <h2>${obj.data[i].title}</h2><hr>
      //             <p>${obj.data[i].desc}</p>
      //             </div>
      //             </a>
      //             </li>`;
      //           // $(".anli ul").append(str);
      //           // $(".anli ul li a")[i].onclick = ()=>{_this.toNextPage(obj.data[i].courseid)};
      //         }
      //       });
      //     } else {
      //       console.log("请求错误");
      //     }
      //   }
      // });
    }
  }
}
</script>

<style>
.kb1 {
  width: 100%;
  height: 25px;
  /* height: 1rem; */
}
</style>



// WEBPACK FOOTER //
// src/views/Example.vue